import { useCallback, useState } from "react";

export default function useLibraryPageState() {
  const [isSaving, setIsSaving] = useState(false);
  const [saveError, setSaveError] = useState("");
  const [isEditorOpen, setIsEditorOpen] = useState(false);

  const openEditor = useCallback(() => {
    setSaveError("");
    setIsEditorOpen(true);
  }, []);

  const closeEditor = useCallback(() => {
    setIsEditorOpen(false);
  }, []);

  return {
    isSaving,
    setIsSaving,
    saveError,
    setSaveError,
    isEditorOpen,
    openEditor,
    closeEditor,
  };
}
